<script lang="ts" setup>
import CategoryItem from '@/pages/services/components/CategoryItem.vue'
import Process from '@/pages/services/components/Process.vue'
import Faq from '@/pages/services/components/Faq.vue'
import Other from '@/pages/services/components/Other.vue'
import useSeo from './seo'

const lists = ref([
  {
    image: './images/services/warranty.jpg',
    title: '註冊新產品',
    link: '/services/warranty/form',
    rotate: 0
  },
  {
    image: './images/services/search.jpg',
    title: '查詢保固',
    link: '/member/service',
    rotate: '-45'
  }
])

const processData = ref([
  {
    pic: './images/services/warranty/step1.jpg',
    title: '登入恆隆行會員',
    text: '完成申請後，可自行查詢保固審核進度'
  },
  {
    pic: './images/services/warranty/step2.jpg',
    title: '填寫商品資訊',
    text: '需包含品牌、型號、機身序號等資訊'
  },
  {
    pic: './images/services/warranty/step3.jpg',
    title: '填寫發票資訊',
    text: '可掃描 QR code，填寫發票日期及購買通路 '
  },
  {
    pic: './images/services/warranty/step4.jpg',
    title: '上傳發票照片',
    text: '提供購買發票或出貨單憑證照片，以供審核'
  },
  {
    pic: './images/services/warranty/step5.jpg',
    title: '審核及啟用',
    text: '保固審核通過後，即享 VIP 售後服務'
  }
])

const faqList = ref([
  {
    title: '申請保固註冊前，需要準備哪些資料?',
    text: '機身序號、發票和出貨單'
  },
  {
    title: '如果沒有發票要怎麼辦?',
    text: '請聯繫客服'
  },
  {
    title: '預購商品要如何申請保固，以及起算日期?',
    text: '上傳發票＋出貨單，保固日期以出貨單日期起算。'
  },
  {
    title: '如何查詢保固註冊的申請審核進度?',
    text: '登入會員點選保固註冊進度查詢'
  },
  {
    title: '如何查詢完成保固的產品?',
    text: '登入會員即可查詢已登入保固之產品'
  },
  {
    title: '恆隆行直營通路（恆隆行專櫃及線上購物）購買商品，是否需要申請保固註冊?',
    text: '於恆隆行專櫃及恆隆行官方線上購物，購買商品皆享自動保固。'
  },
  {
    title: '在KOL開團購買恆隆行商品，是否需要申請保固註冊?',
    text: '需要，完成保固以保障售後服務權益。'
  }
])

const isShow = ref(false)
const processRef = ref(null)
onMounted(() => {
  isShow.value = true
  useImagesLoaded('.service-inner img').then(() => {
    processRef.value?.initAni()
  })
})

useSeo()
</script>

<template>
  <section class="service-inner">
    <div class="service-inner__side">
      <Intro subtitle="warranty" :data="{
        title: '保固註冊'
      }" class="align-left" />
      <div class="service-inner__side__lists">
        <ul class="lists">
          <li v-for="(item, index) in lists" :key="index">
            <CategoryItem :data="{ ...item }" />
          </li>
        </ul>
      </div>
    </div>
    <div class="service-inner__rightPic square__pic h__pic" :class="{ isShow: isShow }">
      <Nimg src="./images/services/warranty/main.jpg" />
    </div>
    <Process class="service-inner__process full" enTitle="process" twTitle="註冊步驟" :data="processData"
      ref="processRef" />
    <Faq class="service-inner__faq full" :items="faqList" />
    <Other class="service-inner__other full" />
  </section>
</template>

<style lang="scss" scoped>
.service-inner {
  &__fast {
    margin-bottom: toRem(160);
  }
}
</style>
